<template>
  <div class="detail-wrapper">
    <template v-if="loading">
      <div class="skeleton-wrapper">
        <van-skeleton title :row="3" />
      </div>
    </template>
    <template v-else>
      <div class="swipe-wrapper">
        <van-swipe class="swiper" indicator-color="#e7b170">
          <van-swipe-item
            v-for="(cover, index) in item.covers"
            :key="index"
          >
            <van-image
              width="100%"
              height="100%"
              fit="fill"
              :src="cover"
              @click.native="imagePreviewHandler(index)"
            />
          </van-swipe-item>
        </van-swipe>
        <span class="back" @click="back">
          <van-icon name="arrow-left" />
        </span>
      </div>
      <div class="info">
        <p class="worth-wrapper">
          <template v-if="item.creditsNeeded !== null">
            {{ item.creditsNeeded }}积分
          </template>
          <span v-if="item.creditsNeeded !== null && item.cashNeeded !== null">&</span>
          <template v-if="item.cashNeeded !== null">
            ¥<span v-money="item.cashNeeded" />
          </template>
        </p>
        <p class="title">{{ item.title }}</p>
        <p class="label">{{ item.summary }}</p>
      </div>
      <div class="detail" v-html="item.detail" />
      <div class="pay-wrapper">
        <van-button class="pay-button" @click="payHandler">立即购买</van-button>
      </div>
    </template>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { Commodities } from '@/api'
import { mixinWxShare } from '@/mixins'

export default {
  name: 'Detail',
  mixins: [mixinWxShare],
  data: () => ({
    loading: true,
    commodityId: '',
    item: {}
  }),
  async mounted () {
    try {
      const { id } = this.$route.params
      this.commodityId = id
      const { commodity: item } = await Commodities.detail({ id })
      this.item = item
      this.loading = false
    } catch (error) {
      console.log(error)
    }
  },
  methods: {
    ...mapActions(['updateCommoditie']),
    back () {
      this.$router.push({ name: 'studio-commodities' })
    },
    imagePreviewHandler (index) {
      this.$ImagePreview({
        images: this.item.covers,
        startPosition: index,
        closeable: true
      })
    },
    payHandler () {
      this.updateCommoditie(this.item)
      this.$router.push({
        name: 'pay-commoditie-id',
        params: {
          id: this.commodityId
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.detail-wrapper {
  @include mh-bgc(100vh, #F4F4F4);
  .skeleton-wrapper {
    background-color: #fff;
    padding: 20px 0;
  }
  .swipe-wrapper {
    position: relative;
    .van-swipe-item {
      height: 211px;
    }
    .back {
      @include wh(32px, 32px);
      @include sc(17px, #fff);
      @include tc(38px);
      position: absolute;
      left: 13px;
      top: 7px;
      border-radius: 50%;
      background-color: rgba(0,0,0,0.45);
    }
  }
  .info {
    padding: 16px;
    background-color: #fff;
    .worth-wrapper {
      @include sc($font-size-md, #F24724);
      @include lw(14px, 500);
      padding-bottom: 18px;
    }
    .title {
      @include sc($font-size-lg, $color-text-heavy);
      @include lw(16px, 500);
      padding-bottom: 8px;
    }
    .label {
      @include sc($font-size-lg, $color-text-light);
      @include lw(20px, 400);
    }
  }
  .detail {
    margin-top: 16px;
    padding: 16px 16px 75px;
    background-color: #fff;
  }
  .pay-wrapper {
    @include bottomfix(32px);
    @include wh(343px, inherit);
    left: 50%;
    transform: translateX(-50%);
    .pay-button {
      @include lg-radius(#ECCEA2, #E7B170, 4px);
      @include normal-button(100%, 39px);
      @include sc($font-size-lg, #fff);
    }
  }
}
</style>
